module.exports = __webpack_public_path__ + "a70b32d0609b162db211927e72a218d4.svg";